import { render, staticRenderFns } from "./addressCheck.vue?vue&type=template&id=65cf0677&"
import script from "./addressCheck.vue?vue&type=script&lang=js&"
export * from "./addressCheck.vue?vue&type=script&lang=js&"
import style0 from "./addressCheck.vue?vue&type=style&index=0&id=65cf0677&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports